const SHOW_REG_SUCCESS_STATUS = 'SHOW_REG_SUCCESS_STATUS';
const SHOW_REG_INBOX_SUCCESS_STATUS = 'SHOW_REG_INBOX_SUCCESS_STATUS';
const SHOW_REG_ERROR_STATUS = 'SHOW_REG_ERROR_STATUS';
const HIDE_REG_STATUS = 'HIDE_REG_STATUS';

export type ActiveRegStatusNotificationActionType =
  | typeof SHOW_REG_SUCCESS_STATUS
  | typeof SHOW_REG_INBOX_SUCCESS_STATUS
  | typeof SHOW_REG_ERROR_STATUS
  | typeof HIDE_REG_STATUS;

export {
  SHOW_REG_SUCCESS_STATUS,
  SHOW_REG_INBOX_SUCCESS_STATUS,
  SHOW_REG_ERROR_STATUS,
  HIDE_REG_STATUS,
};
